// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jPBh","icon":"styles_icon__1Mrgx"};